module.exports = "pegasus/assets/blocks/column-12-theme2.png";